import moment from 'moment';
import i18n from "i18next";
import Backend from "i18next-xhr-backend";
import { initReactI18next } from "react-i18next";

const getInitialLanguage = () => {
    try {
        const persistedState = localStorage.getItem('persist:root');
        if (persistedState) {
            const parsed = JSON.parse(persistedState);
            const languageState = JSON.parse(parsed.language || '"en"');
            return languageState;
        }
    } catch (error) {
        console.warn('Could not parse persisted language state:', error);
    }
    return "en";
};

i18n.use(Backend)
    .use(initReactI18next)
    .init({
        lng: getInitialLanguage(),
        backend: {
            loadPath: "/assets/i18n/{{ns}}/{{lng}}.json?date=" + moment(),
        },
        fallbackLng: "en",
        debug: false,
        ns: ["translations"],
        defaultNS: "translations",
        interpolation: {
            escapeValue: false,
        },
        react: {
            wait: true,
        },
    });

export default i18n;